/**
 * Parses a 1-based instrument jump index from the Go to # control.
 * Accepts only whole decimal digit strings (rejects decimals, signs, scientific notation).
 * Returns null when empty, non-integer, zero, or out of range for instrumentCount.
 */
export const parseInstrumentJumpIndex = (value: string, instrumentCount: number): number | null => {
  if (!Number.isInteger(instrumentCount) || instrumentCount < 1) return null

  const trimmedValue = value.trim()
  if (trimmedValue === '' || !/^\d+$/.test(trimmedValue)) return null

  const pageIndex = Number.parseInt(trimmedValue, 10)
  if (pageIndex < 1 || pageIndex > instrumentCount) return null

  return pageIndex
}
